import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Component from './Component';
import {getUserOrders} from "../Actions";

const stp = (s) => ({
  orders: s.userOrders.orders,
  cities: s.main.cities,
});

const dtp = (d) => ({
  getUserOrders: () => {
    d(getUserOrders())
  },
});

export default withRouter(connect(stp, dtp)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/UserOrders/List/index.js